import { TYPES, RELEASE_FLOW_STEPS } from "./releaseFlowTypes";

export const initialState = {
  isOpen: false,
  step: RELEASE_FLOW_STEPS.RELEASE_DESTINATION,
  contentId: null,
  reload: () => {},
  onSuccess: () => {},
  attachments: [],
  destinations: {},
  originalDestinations: {},
  oldVersions: {},
  keep: {},
  originalKeep: {},
  observationEnabled: { channel: false, production: false, cultureHub: false },
  observationText: { channel: "", production: "", cultureHub: "" },
  isSubmitting: false,
};

const toggleMapDestination = (map, key, destination) => ({
  ...map,
  [key]: {
    ...map[key],
    [destination]: !map[key]?.[destination],
  },
});

const toggleAllMapDestination = (map, keys, destination, checked) => {
  const next = { ...map };
  keys.forEach((key) => {
    next[key] = { ...next[key], [destination]: checked };
  });
  return next;
};

export function releaseFlowReducer(state, action) {
  const { type, payload } = action;

  switch (type) {
    case TYPES.OPEN:
      return {
        ...initialState,
        isOpen: true,
        step: RELEASE_FLOW_STEPS.RELEASE_DESTINATION,
        contentId: payload.contentId,
        reload: payload.reload,
        onSuccess: payload.onSuccess,
        attachments: payload.attachments,
        destinations: payload.destinations,
        originalDestinations: payload.originalDestinations,
        oldVersions: payload.oldVersions,
        keep: payload.keep,
        originalKeep: payload.originalKeep,
      };

    case TYPES.CLOSE:
      // Keep the rest of the state (attachments/destinations/etc.) intact so the
      // Dialog's closing transition still shows the previous content instead of
      // flashing empty state while it fades out. Data is fully reset on the next OPEN.
      return { ...state, isOpen: false };

    case TYPES.GO_TO_VERSION_MANAGEMENT:
      return { ...state, step: RELEASE_FLOW_STEPS.RELEASE_VERSION_MANAGEMENT };

    case TYPES.GO_BACK_TO_DESTINATION:
      return { ...state, step: RELEASE_FLOW_STEPS.RELEASE_DESTINATION };

    case TYPES.TOGGLE_DESTINATION:
      return {
        ...state,
        destinations: toggleMapDestination(
          state.destinations,
          payload.key,
          payload.destination
        ),
      };

    case TYPES.TOGGLE_ALL_DESTINATIONS:
      return {
        ...state,
        destinations: toggleAllMapDestination(
          state.destinations,
          Object.keys(state.destinations),
          payload.destination,
          payload.checked
        ),
      };

    case TYPES.TOGGLE_KEEP_VERSION:
      return {
        ...state,
        keep: toggleMapDestination(
          state.keep,
          payload.key,
          payload.destination
        ),
      };

    case TYPES.TOGGLE_KEEP_ALL_VERSIONS:
      return {
        ...state,
        keep: toggleAllMapDestination(
          state.keep,
          Object.keys(state.keep),
          payload.destination,
          payload.checked
        ),
      };

    case TYPES.SET_OBSERVATION_ENABLED:
      return {
        ...state,
        observationEnabled: {
          ...state.observationEnabled,
          [payload.destination]: payload.enabled,
        },
      };

    case TYPES.SET_OBSERVATION_TEXT:
      return {
        ...state,
        observationText: {
          ...state.observationText,
          [payload.destination]: payload.text,
        },
      };

    case TYPES.SET_SUBMITTING:
      return { ...state, isSubmitting: payload.isSubmitting };

    default:
      return state;
  }
}
